import { Component, OnInit } from '@angular/core';
import { BackgroundService } from 'src/app/shared/services/background.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {
  constructor(private header: BackgroundService) {}

  ngOnInit() {
    this.header.setValue({ title: 'העמוד לא נמצא', pageTitle: 'העמוד לא נמצא', tall: true, logo: false });
  }
}
